/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import RangeInput from '../../../../common/RangeInput/RangeInput'

/**
 * Will return the value of the input or the value of the label
 *
 * @param {any} value
 * @returns {number} the value to use
 */
const returnValue = (value, props) => {
    switch (value) {
        case 0:
            return props.minExcession
        case 1:
            return 500
        case 2:
            return 1000
        case 3:
            return props.maxExcession
        case props.minExcession:
            return 0
        case 500:
            return 1
        case 1000:
            return 2
        case props.maxExcession:
            return 3
        default:
            return

    }
}

/**
 * Will generate the measurements lines in the layour
 *
 * @param {any} N
 * @returns {ReactDOM}
 */
const generateMeasurements = (N) => {
    let array = Array.apply(null, { length: N }).map(Number.call, Number)
    return array.map((item) => {
        return (
            <div className={`measurements measurements-excess-${item + 1}`} key={item} />
        )
    })
}

const VariationExcess = (props: any) => (
    <div className="adjustment">
        <div className="adjustment__title">Excess:</div>
        <div className="adjustment__range">
            {generateMeasurements(4)}
            <RangeInput
                onChange={(value) => { props.onChange(returnValue(value, props)) }}
                value={returnValue(props.value, props)}
                max={3}
                min={0}
            />
        </div>
        <div className="adjustment__result">£{props.value}</div>
    </div>
)

export default VariationExcess



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05cp/components/VariationExcess.tsx